function addTotal(cartTotal) {
  let newCartTotal = cartTotal.replace(/\$/g, "");
  newCartTotal = parseFloat(newCartTotal);
  console.log(newCartTotal);
  if (localStorage.getItem("realift:realfoot:session")) {
    if (typeof window.gtag === "function") {
      gtag("event", "realsize_add_total", {
        event_category: "RealSize",
        event_label: "RealSize Add Total",
        value: newCartTotal,
        send_to: "G-WZ8TG88L6Z",
      });
      gtag("event", "realsize_add_transaction", {
        event_category: "RealSize",
        event_label: "RealSize Add Transaction",
        value: 1,
        send_to: "G-WZ8TG88L6Z",
      });
    }
  }
}

window.onload = function () {
  setTimeout(function () {
    // $(document).on("click", '[class="mbcOverlayOnCheckout"]', function () {
    //   jQuery.getJSON("/cart.js", function (cart) {
    //     console.log("Clicked");
    //     addTotal("$" + cart.total_price / 100);
    //   });
    // });

    const checkout = document.querySelectorAll(".mbcOverlayOnCheckout");
    for(let i = 0; i < checkout.length; i++) {
      checkout[i].addEventListener("click", function() {
        jQuery.getJSON("/cart.js", function (cart) {
          addTotal("$" + cart.total_price / 100);
        });
      })
    }
    

    $(document).on('click', '[data-testid="ShopifyPay-button"]', function() {
      jQuery.getJSON("/cart.js", function (cart) {
        addTotal("$" + cart.total_price / 100);
      });
    });

    // const checkout = document.querySelector('[name="checkout"]');
    // if(checkout) {
    //   console.log("Checkout")
    //   checkout.addEventListener("click", function () {
    //     jQuery.getJSON("/cart.js", function (cart) {
    //       console.log("Clicked");
    //       addTotal("$" + cart.total_price / 100);
    //     });
    //   });
    // } else {
    //   console.log("Did not find checkout button")
    // }

    // Shopify

    // const shopifyPay = document.querySelector('[data-testid="ShopifyPay-button"]');
    // if (shopifyPay) {
    //   shopifyPay.addEventListener("click", function () {
    //     jQuery.getJSON("/cart.js", function (cart) {
    //       console.log("Clicked");
    //       addTotal("$" + cart.total_price / 100);
    //     });
    //   });
    // } else {
    //   console.log("Shopify element doesn't exist");
    // }
    
    // Google

    // const googlePay = document.querySelector('[data-testid="GooglePay-button"]');
    // googlePay.addEventListener("click", function () {
    //   jQuery.getJSON("/cart.js", function (cart) {
    //     addTotal("$" + cart.total_price / 100);
    //   });
    // });

    // Facebook/Meta

    // const facebookPay = document.querySelector('[data-testid="FacebookPay-button"]');
    // facebookPay.addEventListener("click", function () {
    //   jQuery.getJSON("/cart.js", function (cart) {
    //     addTotal("$" + cart.total_price / 100);
    //   });
    // });

    // Sezzle

    // const sezzlePay = document.querySelector(".sezzle-checkout-button");
    // sezzlePay.addEventListener("click", function () {
    //   jQuery.getJSON("/cart.js", function (cart) {
    //     addTotal("$" + cart.total_price / 100);
    //   });
    // });
  }, 1000);
  // PayPal

  // window.focus();

  // window.addEventListener("blur", () => {
  //   setTimeout(() => {
  //     if (document.activeElement.tagName === "IFRAME") {
  //       jQuery.getJSON("/cart.js", function (cart) {
  //         addTotal("$" + cart.total_price / 100);
  //       });
  //     }
  //   });
  // }, { once: false });
};
